<template>
    <loader :show="showLoader" />
    <layout />
</template>

<script lang="ts">
    import { defineComponent, computed } from 'vue'
    import { useStore }                  from 'vuex'
    import globalStoreGetters            from '@constans/store/global/globalStoreGetters'
    import layout                        from '@views/layout.vue'
    import loader                        from '@components/loader.vue'

    export default defineComponent({
        components: {
            layout,
            loader
        },
        setup() {
            const store = useStore()
            const showLoader = computed(() => store.getters[`global/${ globalStoreGetters.GET_LOADING }`])

            if (process.env.NODE_ENV !== 'production') {
                console.log('%c Bostad Direkt Internal booted!', 'font-weight: bold; font-size: 50px;color: red; text-shadow: 3px 3px 0 rgb(217,31,38) , 6px 6px 0 rgb(226,91,14) , 9px 9px 0 rgb(245,221,8) , 12px 12px 0 rgb(5,148,68) , 15px 15px 0 rgb(2,135,206) , 18px 18px 0 rgb(4,77,145) , 21px 21px 0 rgb(42,21,113)')
            }

            return {
                showLoader
            }
        }
    })
</script>